// extracted by mini-css-extract-plugin
export default {"message-text":"Message_message-text__FBgdt","align-left":"Message_align-left__-L0Ef","align-center":"Message_align-center__qIfDo"};